import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useSnackSettingsQuery } from "../model";
import { DesignSnackSettingsPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const DesignSnackSettingsContainer = ({ hotelID }: Props) => {
	const { data } = useSnackSettingsQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID })} />;
	}

	return <DesignSnackSettingsPresenter hotelID={hotelID} data={data} />;
};

DesignSnackSettingsContainer.displayName = "DesignSnackSettingsContainer";
